import React, { Component } from 'react';
import { connect } from 'react-redux'
import {toast} from "react-toastify";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import validator from "validator";

import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import TitleText from "../Components/TitleText";
import {withRouter} from "react-router-dom";
import ParagraphText from "../Components/ParagraphText";
import TopContent from "../Components/TopContent";
import styled from "styled-components";
import LimitedWidthSection from "../Components/LimitedWidthSection";
import TextSection from "../Components/TextSection";

const Monospace = styled.span`
  font-family: monospace;
  background-color: #0fb9bd;
  padding: 10px;
  font-weight: 400;
  border-radius: 2px;
  word-break: break-all;
  line-height: 30px;
`;

const Clickable = styled.span`
  cursor: pointer;
`;

const UrlBox = styled.div`
  max-width: 80%;
  overflow-x: hidden;
  white-space: pre-wrap;      /* CSS3 */   
  white-space: -moz-pre-wrap; /* Firefox */    
  white-space: -pre-wrap;     /* Opera <7 */   
  white-space: -o-pre-wrap;   /* Opera 7 */    
  word-wrap: break-word;
`;

class Page extends Component {
  componentDidMount() {
    if(!this.props.recipientEmail || !validator.isEmail(this.props.recipientEmail)) {
      toast.info('Please enter a valid gift recipient email address');
      return this.props.history.push('/');
    }
  }
  onCopy() {
    toast.info(`Link copied to clipboard!`);
  }
  render() {
    const debug = process.env.REACT_APP_DEBUG_MODE === 'true';

    const host = debug ? 'http://localhost:3000' : 'https://biterica.com';
    const url = `${host}/giftbasket/${this.props.recipientEmail}`;
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <div className="spacer-40px" />
            <Centered>
              <TitleText>Bitcoin Gift Basket</TitleText>
            </Centered>
            <div className="spacer-20px" />
            <TextSection>
              <Centered>
                <div className="spacer-20px" />
                  <Centered>
                    <div className="spacer-20px" />
                    <ParagraphText> You are on you way to receiving Bitcoin gifts!  Below is your personalized Bitcoin url. Share it as you please.</ParagraphText>
                    <div className="spacer-40px" />
                    <ParagraphText> Click to copy to clipboard </ParagraphText>
                    <div className="spacer-20px" />
                    <UrlBox>
                      <CopyToClipboard text={url} onCopy={() => this.onCopy()}>
                        <Clickable>
                          <Monospace>{url}</Monospace>
                        </Clickable>
                      </CopyToClipboard>
                      &nbsp;&nbsp;
                    </UrlBox>

                    <div className="spacer-40px" />
                    <TitleText>
                      <a href={url} target="_blank"><i className="fas fa-external-link-alt"></i></a>
                      &nbsp;&nbsp;
                      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(url)}`} target="_blank"><i className="fab fa-facebook-square"></i></a>
                      &nbsp;&nbsp;
                      <a href={`https://twitter.com/intent/tweet?url=${encodeURI(url)}&text=${encodeURIComponent("Gift me some Bitcoin!")}`} target="_blank"><i className="fab fa-twitter-square"></i></a>
                    </TitleText>
                    <div className="spacer-20px" />
                    <ParagraphText>Bitcoin gifts will be delivered directly to the email address provided.</ParagraphText>
                    <div className="spacer-40px" />
                  </Centered>
              </Centered>
            </TextSection>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

const mapStateToProps = (state) => ({
  recipientEmail: state.gift.recipientEmail,
});

export default connect(mapStateToProps)(withRouter(Page));


// WEBPACK FOOTER //
// ./src/Pages/RequestPage.js